import request from "../../../helpers/request";

export interface IRequestGetRptHistoricoDispositivos {
  idLoja: string;
  reportType: string;
  dataIni: string;
  dataFim: string;
}

export const getRptHistoricoDispositivos = async ({
  idLoja,
  reportType,
  dataIni,
  dataFim,
}: IRequestGetRptHistoricoDispositivos) => {
  const _reportType = reportType ? `reportType=${reportType}` : ""
  const _dataIni = dataIni ? `&dataIni=${dataIni}` : ""
  const _dataFim = dataFim ? `&dataFim=${dataFim}` : ""
  const _idLoja = idLoja ? idLoja : ""

  const str = `${_reportType}${_dataIni}${_dataFim}`
  const url = `${process.env.REACT_APP_API}/Relatorio/RptHistoricoDispositivos/${_idLoja}?${str}`;
  const result = await request({ url, responseType: "blob" });
  return result;
};
